export default __webpack_public_path__ + "static/media/Liberator's Halberd.a2788d11.jpg";